/**
 * Analytics Page
 *
 * Comprehensive reporting and analytics dashboard for compliance metrics.
 */

import React from 'react';
import { AnalyticsPage as AnalyticsPageComponent } from '../analytics';

export default function AnalyticsPage() {
  return <AnalyticsPageComponent />;
}
